import { RemoteGetByIdEntities } from 'data/usecases';
import { makeApiUrlEntities } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetByIdEntities = (): RemoteGetByIdEntities => {
  return new RemoteGetByIdEntities(makeApiUrlEntities(), makeAxiosHttpClient());
};
